<template>
    <page-loading v-if="loading"></page-loading>
    <form-container v-else>
        <step-form-heading v-if="!props.agentId" :icon="faSparkle">
            New Agent

            <template v-slot:description>
                <p>Define the rules this Agent should enforce. Be explicit and specific.</p>
                <p>Describe what the message should include, avoid, or match.</p>
            </template>
        </step-form-heading>

        <page-header v-else class="mb-6 lg:mb-12" data-test="ai-message-vetting-agent-header">
            <template v-slot:subtitle>
                <a
                    :href="`/settings/teams/${teamId}#/ai-blast-vetting`"
                    class="no-underline! text-sky-600! text-base font-normal"
                >
                    <font-awesome-icon widthAuto class="mr-1" :icon="faArrowLeft"></font-awesome-icon>
                    All Agents
                </a>
            </template>

            {{ agent?.name }}
        </page-header>

        <div :class="{ 'grid grid-cols-12': props.agentId }">
            <page-sidebar
                v-if="props.agentId"
                appearance="nested"
                :links="sidebarLinks"
                data-test="ai-message-vetting-agent-sidebar"
            ></page-sidebar>

            <slot></slot>
        </div>
    </form-container>
</template>

<script setup lang="ts">
import PageLoading from '~/components/general/PageLoading.vue';
import FormContainer from '~/components/general/FormContainer.vue';
import StepFormHeading from '~/components/general/StepFormHeading.vue';
import PageHeader from '~/components/general/PageHeader.vue';
import PageSidebar from '~/components/general/PageSidebar.vue';
import { computed, onMounted } from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faArrowLeft, faSparkle } from '@fortawesome/pro-solid-svg-icons';
import { useAiMessageVettingAgentDetails } from '~/composables/useAiMessageVettingAgentDetails';

const props = defineProps<{
    agentId?: number;
}>();

const teamId = Spark.state.currentTeam.id;
const { mount, agent, loading } = useAiMessageVettingAgentDetails();

const sidebarLinks = computed(() => [
    {
        href: `/settings/teams/${teamId}/ai-agents/message-vetting/${props.agentId}`,
        label: 'Details',
    },
    {
        href: `/settings/teams/${teamId}/ai-agents/message-vetting/${props.agentId}/usage`,
        label: 'Usage',
    },
]);

onMounted(() => {
    mount(props.agentId);
});
</script>
